import React from 'react';

const Footer = ({ theme }) => {
  const linkClass = theme === 'dark'
    ? 'text-gray-400 hover:text-green-400 underline underline-offset-2 transition-colors duration-200'
    : 'text-gray-500 hover:text-green-600 underline underline-offset-2 transition-colors duration-200';

  const dividerClass = theme === 'dark' ? 'text-gray-600' : 'text-gray-400';

  return (
    <footer className={`py-8 mt-12 border-t ${theme === 'dark' ? 'bg-gray-800 border-gray-700 text-gray-400' : 'bg-gray-200 border-gray-300 text-gray-600'}`}>
      <div className="container mx-auto px-4 text-center text-xs">
        <p className="font-bold mb-2">
          Pay4Referral © 2025 di Dynamic-Web Srls – P.Iva 03034040356 – Tutti i diritti sono riservati
        </p>
        <p className="mb-2">
          Rag. Sociale: DYNAMIC-WEB SRLS - SOCIETA' A RESPONSABILITA' LIMITATA SEMPLIFICATA
        </p>
        <p className="mb-4">
          Questa applicazione è stata realizzata da Dynamic-Web Srls e utilizza Supabase per l'archiviazione sicura dei dati.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2">
          <a
            href="https://privacy-policy.pay4referral.dynamic-web.space"
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            Privacy Policy
          </a>
          <span className={dividerClass}>|</span>
          <a
            href="https://cookie-policy.pay4referral.dynamic-web.space"
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            Cookie Policy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;